<template>
  <!-- sidebar menu: : style can be found in sidebar.less -->
  <div :key="currRole">
    <div class="role-header">Role: {{ currRole }}</div>
    <!-- Only show role switch link for actual Admin users -->
    <div v-if="isAdminUser" class="role-switch" @click="switchRole">
      <i class="fa fa-exchange"></i>
      <span>Switch to {{ currRole === "Admin" ? "Sales" : "Admin" }}</span>
    </div>
    <div v-if="isAdminUser" class="sidebar-divider"></div>
    <ul class="sidebar-menu">
      <router-link
        class="treeview"
        tag="li"
        v-for="(route, i) in roleRoutesSingle"
        :to="route.path"
        :key="i"
        replace
      >
        <a>
          <i class="fa fa-circle-o text-aqua"></i>
          <span>{{ route.title }}</span>
        </a>
      </router-link>
      <template v-for="(route, i) in roleRoutesWithChildren">
        <li v-if="route.separatorBefore" :key="'sep' + i" class="sidebar-divider-li"></li>
        <li
          class="treeview"
          :class="{ active: route.isActive }"
          :key="'c' + i"
        >
          <a href="#" @click="subMenuClick(route)">
            <i class="fa fa-laptop"></i>
            <span>{{ route.title }}</span>
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            <router-link
              v-for="(r, i) in route.children"
              :key="'t' + i"
              :to="r.path"
              tag="li"
              active-class="active"
              replace
            >
              <a @click="routeClicked(r)">
                <i class="fa fa-dashboard text-light-blue"></i>
                <span>{{ r.title }}</span>
              </a>
            </router-link>
          </ul>
        </li>
      </template>
    </ul>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Menu",
  data() {
    return {
      adminRoutes: [
        {
          title: "Dashboard",
          icon: "fa fa-dashboard text-light-blue",
          path: "/main/dashboard/admin",
        },
        {
          title: "Partners",
          icon: "fa fa-dashboard text-light-blue",
          isActive: false,
          children: [
            {
              path: "/main/partner/list",
              title: "View Partners",
            },
            {
              path: "/main/partner/meterlimit",
              title: "Meter Limit",
            },
            // {
            //   path: "/main/partner/meterblacklist",
            //   title: "Meter Blacklists",
            // },
            {
              path: "/main/partner/terms",
              title: "Subscription Terms",
            },
            {
              path: "/main/partner/patterns",
              title: "Partner Patterns",
            },
            {
              path: "/main/partner/uripatterns",
              title: "URI Patterns",
            },
          ],
        },
        {
          title: "Party",
          icon: "fa fa-dashboard text-light-blue",
          isActive: false,
          children: [
            {
              path: "/main/party/consortium",
              title: "View Consortiums",
            },
            {
              path: "/main/party/institution",
              title: "View Institutions",
            },
            {
              path: "/main/party/subscription",
              title: "View Subscriptions",
            },
            {
              path: "/main/party/ipranges",
              title: "View/Edit IP Ranges",
            },
          ],
        },
        {
          title: "Usage Units",
          icon: "fa fa-dashboard text-light-blue",
          isActive: false,
          children: [
            {
              path: "/main/usage/orcid-assign",
              title: "Assign ORCID Units",
            },
            {
              path: "/main/usage/orcid-bulk-assign",
              title: "Bulk Assign ORCID Units",
            },
          ],
        },
        {
          title: "PAM Users",
          icon: "fa fa-dashboard text-light-blue",
          isActive: false,
          separatorBefore: true,
          children: [
            {
              path: "/main/users/list",
              title: "View Users",
            },
            // {
            //   path: "/main/users/add",
            //   title: "Add New User",
            // },
            {
              path: "/main/users/actions",
              title: "Associate Orgs",
            },
            {
              path: "/main/users/requests",
              title: "IP Range Change Requests",
            },
          ],
        },
      ],
      salesRoutes: [
        {
          title: "Dashboard",
          icon: "fa fa-dashboard text-light-blue",
          path: "/main/dashboard/sales",
        },
        {
          title: "Usage Stats",
          isActive: false,
          children: [
            {
              path: "/main/usage/summary",
              title: "Usage Summary",
            },
            {
              path: "/main/usage/panel",
              title: "View Usage",
            },
            {
              path: "/main/usage/schedule",
              title: "Schedule Usage Reports",
            },
          ],
        },
        {
          title: "Activation Codes",
          isActive: false,
          children: [
            {
              path: "/main/activation/list",
              title: "View Activation Codes",
            },
            {
              path: "/main/activation/add",
              title: "Add Activation Codes",
            },
          ],
        },
      ],
      librarianRoutes: [
        {
          title: "Dashboard",
          icon: "fa fa-dashboard text-light-blue",
          path: "/main/dashboard/librarian",
        },
        {
          title: "Party",
          icon: "fa fa-dashboard text-light-blue",
          isActive: false,
          children: [
            {
              path: "/main/party/librarian",
              title: "View Associated Orgs",
            },
            {
              path: "/main/party/ipranges",
              title: "View IP Ranges",
            },
          ],
        },
        {
          title: "Usage Stats",
          isActive: false,
          children: [
            // {
            //   path: "/main/usage/summary",
            //   title: "Usage Summary",
            // },
            {
              path: "/main/usage/panel",
              title: "View Usage",
            },
            {
              path: "/main/usage/schedule",
              title: "Schedule Usage Reports",
            },
          ],
        },
      ],
      activeRoutes: [],
      currRole: "",
    };
  },
  computed: {
    ...mapGetters("login", ["loggedInUser"]),
    isAdminUser() {
      return this.loggedInUser && this.loggedInUser.role === "Admin";
    },
    roleRoutesWithChildren() {
      const routes = this.getRoutesByRole(this.currRole);
      console.log("Computed Routes:", routes);
      return routes.filter((route) => route.children);
    },
    roleRoutesSingle() {
      return this.getRoutesByRole(this.currRole).filter(
        (route) => !route.children
      );
    },
  },
  watch: {
    loggedInUser: {
      handler(newUser) {
        if (newUser && newUser.role) {
          // Only set currRole from loggedInUser if it hasn't been manually switched
          // This allows Admin users to switch between Admin and Sales views
          if (!this.currRole || (newUser.role === "Admin" && this.currRole === newUser.role)) {
            this.currRole = newUser.role;
            this.updateActiveRoutesAndRedirect();
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.loggedInUser) {
      this.currRole = this.loggedInUser.role;
      this.updateActiveRoutesAndRedirect();
    }
  },
  methods: {
    ...mapActions("login", ["setRole"]),
    switchRole() {
      // Only allow role switching if user is actually an Admin
      if (!this.loggedInUser || this.loggedInUser.role !== "Admin") {
        return;
      }

      this.resetActiveRoutes();
      const newRole = this.currRole === "Admin" ? "Sales" : "Admin";
      this.currRole = newRole;

      // NOTE: Do NOT call setRole() here — that would overwrite the user's actual role.
      // currRole tracks the current view independently.

      this.updateActiveRoutesAndRedirect();
    },
    updateActiveRoutesAndRedirect() {
      this.activeRoutes = this.getRoutesByRole(this.currRole);

      // Check if the current route is accessible in the new role
      const currentPath = this.$route.path;
      let shouldRedirectToDashboard = true;

      // Check if current route exists in the new role's routes
      this.activeRoutes.forEach((route) => {
        if (route.path === currentPath) {
          shouldRedirectToDashboard = false;
        }
        if (route.children) {
          route.children.forEach((child) => {
            if (child.path === currentPath) {
              shouldRedirectToDashboard = false;
              route.isActive = true;
            }
          });
        }
      });

      // Only redirect to dashboard if the current route is not accessible in the new role
      if (shouldRedirectToDashboard) {
        this.$router.push(`/main/dashboard/${this.currRole.toLowerCase()}`);
      }

      // Set active status for the current route
      this.activeRoutes.forEach((item) => {
        if (item.children) {
          item.children.forEach((child) => {
            if (child.path === this.$route.path) {
              item.isActive = true;
            }
          });
        }
      });
    },
    subMenuClick(route) {
      if (route.isActive) {
        route.isActive = false;
        return;
      }
      this.activeRoutes.forEach((r) => {
        if (r.isActive) {
          r.isActive = false;
        }
        if (r.title == route.title) {
          r.isActive = true;
        }
      });
    },
    resetActiveRoutes() {
      const resetRoutes = (routes) => {
        routes.forEach((route) => {
          route.isActive = false;
          if (route.children) {
            resetRoutes(route.children);
          }
        });
      };

      resetRoutes(this.adminRoutes);
      resetRoutes(this.salesRoutes);
      resetRoutes(this.librarianRoutes);
    },
    routeClicked(r) {
      console.log("clicked route", r.title);
    },
    getRoutesByRole(role) {
      switch (role) {
        case "Admin":
          return this.adminRoutes;
        case "Sales":
          return this.salesRoutes;
        case "Librarian":
          return this.librarianRoutes;
        default:
          return this.salesRoutes;
      }
    },
    select(text) {
      console.log("selected", text);
    },
  },
};
</script>
<style scoped>
.role-header {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 600;
  color: black;
  padding: 10px 15px;
  text-transform: uppercase;
  background-color: #ffffff;
  margin-left: 20px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.role-switch {
  display: flex;
  align-items: center;
  padding: 8px 15px 8px 20px;
  font-size: 13px;
  color: #b8c7ce;
  cursor: pointer;
  border-bottom: 1px solid rgba(255,255,255,0.05);
}
.role-switch:hover {
  color: #ffffff;
  background-color: rgba(255,255,255,0.05);
}
.role-switch .fa {
  margin-right: 8px;
  font-size: 13px;
  opacity: 0.7;
}
.sidebar-divider {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.15);
  margin: 6px 15px;
}
.sidebar-divider-li {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.15);
  margin: 6px 15px;
  list-style: none;
}
.treeview .active > .treeview-menu {
  display: block;
}
.sidebar-menu > li > a {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/side-bar/Menu.vue